import { useQuery } from '@apollo/client'
import { useEffect } from 'react'
import { useRegisterManager } from '../../../ng-compat/hooks'
import { useAppDispatch } from '../../../state/hooks'
import { setLspayTippingCalculateBeforeTax } from '../../../state/slices/posState/posStateSlice'
import {
  GET_LSPAY_TIPPING_CONFIGS,
  LspayTippingConfigData,
  LspayTippingConfigRequest,
} from '../../../queries/lspay-tipping-config'

export const useLspayTippingConfig = (): void => {
  const registerManager = useRegisterManager()
  const dispatch = useAppDispatch()
  const outletId = registerManager.getActiveOutlet?.()?.id

  const { data } = useQuery<LspayTippingConfigData, LspayTippingConfigRequest>(
    GET_LSPAY_TIPPING_CONFIGS,
    {
      fetchPolicy: 'network-only',
      skip: !outletId,
      variables: {
        outletIDs: outletId ? [outletId] : [],
      },
    }
  )

  useEffect(() => {
    if (!data || !outletId) {
      return
    }

    const outletConfig = data.lspayTippingConfig?.find(
      config => config.outletID === outletId
    )

    dispatch(
      setLspayTippingCalculateBeforeTax(outletConfig?.calculateBeforeTax)
    )
  }, [data, dispatch, outletId])
}
